module.exports = __webpack_public_path__ + "img/store-standard.4fb97bef.png";